import { StackItem, TextContent, Text } from '@patternfly/react-core';

import './section.css';

export enum SectionVariant {
    Default = 'default',
    Warning = 'warning',
}

interface SectionHelpTextProps {
    helpText: string,
    variant?: SectionVariant,
}

const SectionHelpText = (props: SectionHelpTextProps) => {
    const { helpText, variant } = props;

    const sectionHelpTextVariant = variant || SectionVariant.Default;

    const style = getStyle(sectionHelpTextVariant);

    return (
        <StackItem className="section-item">
            <div className="section-help-text">
                <TextContent>
                    <Text className={style}>
                        {helpText}
                    </Text>
                </TextContent>
            </div>
        </StackItem>
    );

}

export default SectionHelpText;


function getStyle(sectionHelpTextVariant: SectionVariant) {
    switch (sectionHelpTextVariant) {
        case SectionVariant.Warning:
            return 'section-warning';
        case SectionVariant.Default:
        default:
            return '';
    }
}
